import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { useDocumentProductExtractions } from "../../hooks/useProductRecords";

const FAILURE_KEYS: Record<string, string> = {
  too_many_products: "productCatalog.extraction.tooMany",
  insufficient_boosts: "productCatalog.extraction.noBoosts",
};

/** The newest product extraction run of a document, only while it runs or after it failed. */
export function ProductExtractionStatus({ documentId }: { documentId: string | undefined }) {
  const { t } = useTranslation();
  const { data, isError, error } = useDocumentProductExtractions(documentId);

  useEffect(() => {
    if (isError) console.error("Failed to load product extractions", { documentId, error: (error as Error).message });
  }, [isError, error, documentId]);

  if (isError) return <span className="text-sm text-red-600">{t("productCatalog.extraction.statusFailed")}</span>;
  const latest = data?.[0];
  if (latest?.status === "extracting") {
    return (
      <span className="flex items-center gap-1">
        <Loader2 className="h-4 w-4 animate-spin" />
        {t("productCatalog.extraction.extracting")}
      </span>
    );
  }
  if (latest?.status === "failed") {
    return <span className="text-red-600">{t(FAILURE_KEYS[latest.failure_reason ?? ""] ?? "productCatalog.extraction.failed")}</span>;
  }
  return null;
}
